import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

export default function PaymentSuccess() {
  const navigate = useNavigate();
  const location = useLocation();
  
  // Grab the plan from the query parameters. Default to 'Plan' if not found.
  const searchParams = new URLSearchParams(location.search);
  const plan = searchParams.get('plan') || 'Plan';

  useEffect(() => {
    // After a short delay, redirect to /dashboard while passing a success message.
    const timer = setTimeout(() => {
      navigate('/dashboard', { state: { successMessage: `Congratulations! Your upgrade to the ${plan.charAt(0).toUpperCase() + plan.slice(1)} plan was a resounding success! Your scan limits have been boosted—enjoy an enhanced document processing experience with ClevrScan.` } });
    }, 4000);
    return () => clearTimeout(timer);
  }, [navigate, plan]);

  return (
    <div className="flex items-center justify-center h-screen bg-gray-100 dark:bg-gray-900">
      <div className="text-center p-8 bg-white dark:bg-gray-800 rounded-lg shadow-lg">
        <h1 className="text-3xl font-bold text-green-600 mb-4">Congratulations!</h1>
        <p className="text-xl text-gray-700 dark:text-gray-200">Your transaction was successful!</p>
        <p className="mt-2 text-gray-600 dark:text-gray-300">
          Your upgrade to the {plan.charAt(0).toUpperCase() + plan.slice(1)} plan is now active.
          Enjoy significantly increased scan limits and discover an enhanced experience tailored just for you.
        </p>
        <p className="mt-4 text-gray-500 dark:text-gray-400 text-sm">Redirecting you to your dashboard...</p>
      </div>
    </div>
  );
} 